type EventName =
  | 'track.started'
  | 'track.completed'
  | 'track.challenge_started'
  | 'track.challenge_completed'
  | 'track.challenge_skipped';

interface EventParams {
  track_slug?: string;
  challenge_slug?: string;
  total_challenges?: number;
}

function embedEvent(name: 'track.started', params: { track_slug: string; total_challenges: number }): void;
function embedEvent(name: 'track.completed', params: { track_slug: string; total_challenges: number }): void;
function embedEvent(name: 'track.challenge_started', params: { track_slug: string; challenge_slug: string }): void;
function embedEvent(
  name: 'track.challenge_completed',
  params: { track_slug: string; challenge_slug: string; total_challenges: number },
): void;
function embedEvent(name: 'track.challenge_skipped', params: { track_slug: string; challenge_slug: string }): void;

function embedEvent(name: EventName, params?: EventParams): void {
  const parent = window.parent || window.opener;
  if (parent) {
    parent.postMessage({ event: name, params: params }, '*');
  }
}

export default embedEvent;
